import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { state, refresh } = useAuth();
  const location = useLocation();

  // Kick off the session probe lazily — only when a protected route mounts.
  // Keeps public pages from firing /api/admin/me on every load.
  useEffect(() => {
    if (state === null) refresh();
  }, [state, refresh]);

  if (state === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-[#16A34A] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (state === false) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
